<!-- パスワード変更用のパネル -->
<template lang="html">
  <div id="passowordChangePanel">
    <h1>パスワードの変更</h1>
    <label
      v-if="$store.state.userInfo.user_type !== 'admin'"
      key="current_password"
      class="cate2"
      >
      現在のパスワード:
      <input v-if="!isShownPasswords" type="password" v-model="current_password" />
      <input v-if="isShownPasswords" type="text" v-model="current_password" />
    </label>
    <label class="cate2">新しいパスワード:
      <input v-if="!isShownPasswords" type="password" v-model="new_password" />
      <input v-if="isShownPasswords" type="text" v-model="new_password" />
    </label>
    <label class="opt1"><input type="checkbox" v-model="isShownPasswords" />パスワードを表示する</label>
    <button @click="changePassword" class="square_btn">パスワードを変更</button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      current_password: '',
      new_password: '',
      isShownPasswords: false
    }
  },
  props: [
    'user_id'
  ],
  methods: {
    ...mapActions([
      'changeUserPassword'
    ]),
    changePassword () {
      this.changeUserPassword({
        id: this.user_id,
        currentPassword: this.current_password,
        newPassword: this.new_password
      }).then((res) => {
        if (res) {
          alert('パスワードの変更に成功しました.')
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
label {
  display: block;
}
#passowordChangePanel {
  width: 900px;
  margin-top: 10px;
  padding-top:30px;
  margin-left: auto;
  margin-right: auto;
  /*
  border-style: solid;
  border-color: #E69200;
  border-left: none;
  border-right: none;
  border-bottom: none;
  */
}
h1 {
  padding: 0.5em;
  background: aliceblue;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.23);
  width: 600px;
  margin: auto;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  font-family: "メイリオ", "ヒラギノ丸ゴ ProN", sans-serif;
  font-size: 18px;
}
.cate2 {
  font-family: "メイリオ", "ヒラギノ丸ゴ ProN", sans-serif;
  font-size: 14px;
  margin-bottom: 15px;
  color: #5B5B5B;
}
input {
  border:0;
  font-size:1.3em;
  font-family:Arial, sans-serif;
  color:#aaa;
  border:solid 1px #ccc;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}
input:focus {
  border:solid 1px #EEA34A;
}
.opt1 {
  font-family: "メイリオ", "ヒラギノ丸ゴ ProN", sans-serif;
  font-size: 12px;
  margin-top: 0px;
}
.square_btn {
    margin-top: 13px;
    font-size: 14px;
    position: relative;
    display: inline-block;
    padding: 0.25em 0.5em;
    text-decoration: none;
    color: #FFF;
    background: #FFCC33;/*背景色*/
    border-bottom: solid 2px #d27d00;/*少し濃い目の色に*/
    border-radius: 4px;/*角の丸み*/
    box-shadow: inset 0 2px 0 rgba(255,255,255,0.2), 0 2px 2px rgba(0, 0, 0, 0.19);
}

.square_btn:active {
    border-bottom: solid 2px #fd9535;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.30);
}
</style>



// WEBPACK FOOTER //
// PasswordChangePanel.vue?7d0950dc